import { orchestrator } from 'satcheljs';
import { onFormCancelled, onFormCleared } from '../actions';

orchestrator(onFormCancelled, async () => {
  onFormCleared();
});